import {QueryFunctionContext} from 'react-query';

import request from '../../axios';

const getCommentsList = async (ctx: QueryFunctionContext) => {
  const {data}: {data: ICommentss} = await request.get(
    `api/v2/store/store-comment/${ctx.queryKey[1]}`,
  );
  return data;
};

export default getCommentsList;
